module.exports = __webpack_public_path__ + "img/130-2af548.png";